import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AgentService } from '../services/agent.service';
import { AgentSearchHandler } from './agent-search.handler';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-agent-search',
  templateUrl: './agent-search.component.html',
  styleUrls: ['./agent-search.component.scss'],
})
export class AgentSearchComponent extends AgentSearchHandler {
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
